module.exports = __webpack_public_path__ + "img/MS_Spear.1a0c13cc.png";